import { render, staticRenderFns } from "./IssueTrackers.vue?vue&type=template&id=591fbcb8&"
import script from "./IssueTrackers.vue?vue&type=script&lang=js&"
export * from "./IssueTrackers.vue?vue&type=script&lang=js&"
import style0 from "./IssueTrackers.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports